module.exports = __webpack_public_path__ + "img/punch-card-background.51122fa5.svg";